const urlPattern = process.env.URL_PATTERN;
const intakePath = process.env.INTAKE_PATH;

export const tenantHelpers = {
  store: null,
  getParticipantUrl: () => getUrlFromTenant(tenantHelpers.store),
  getParticipantIntakeUrl: (id) => getIntakeUrl(tenantHelpers.store, id),
  getProductName: () => getProductName(tenantHelpers.store),
}

function getUrlFromTenant(store) {
  const { tenant } = store.getState();
  const { currentTenant } = tenant || {};
  const { slug, absoluteUrl } = currentTenant || {};
  if(!!absoluteUrl) {
    return absoluteUrl;
  }
  else {
    return urlPattern.replace("{slug}", slug);
  }
}

function getIntakeUrl(store, id) {
  var baseAddr = getUrlFromTenant(store);
  if(baseAddr.length > 0) {
    baseAddr += baseAddr.charAt(baseAddr.length - 1) === '/' ? '' : '/';
  }
  var intakeRoute = intakePath.replace("{id}", id);
  return baseAddr + intakeRoute;
}

/** currently just returns the name Connect, but has enough information to switch based on integration type */
function getProductName(store) {
  return "Connect";
}
